// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__DMBnk","menuItems":"Sidebar_menuItems__MArbk","menuItem":"Sidebar_menuItem__Q8-Lq"};